import React, { useCallback, useEffect, useState } from "react";
import { Slider } from "antd";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import * as homePageActions from "../../../actions/homePageActions";
import * as companyActions from "../../../actions/companyActions";
import * as productActions from "../../../actions/productActions";
import classNames from "classnames";
import { useHistory } from "react-router";
import { Form } from 'react-bootstrap';
import Select from "react-select";
import ahmedabad from '../../../public/images/ahmedabad.png';
import banglore from '../../../public/images/banglore.png';
import delhi from '../../../public/images/delhi.png';
import jaipur from '../../../public/images/jaipur.png';
import kolkata from '../../../public/images/kolkata.png';
import mumbai from '../../../public/images/mumbai.png';
import pune from '../../../public/images/pune.png';
import { BiCurrentLocation } from "react-icons/bi";
import Image from "next/image"
import { useRouter } from "next/router";
import Analytics from "../../../common_components/Common/Analytics";
import useDebounce from "../../../common_components/Common/useDebounce";


export default function MobileFilter({ orderBy, filterBy, page, pageChanges, setPageChages, setOpenFilter, TriggerLoader }) {
  const dispatch = useDispatch();
  const router = useRouter()
  const { type, cat, price, truerange } = router.query
  const { getFilteredVehicles, getFilteredCompanies, AddFilterData, getNearByCoordinates, getCities, applyFilter, getVehicleRange, getNearbyCities, getCitybyCoordinates } =
    bindActionCreators(homePageActions, dispatch);

  const { getMainVehicles } = bindActionCreators(productActions, dispatch);
  const { getAllCompanyListWithoutPagination } = bindActionCreators(
    companyActions,
    dispatch
  );
  const { companyData, companyDataLoading } = useSelector(
    (state) => state.company
  );
  const { filterData } = useSelector(
    (state) => state.home
  );

  const { cities, citydata, vehiclerange, filteredCompanies, companiesLoading } = useSelector((state) => state.home);

  const [budget, setBudget] = useState([vehiclerange.minBudget, vehiclerange.maxBudget]);

  const [topSpeed, setTopSpeed] = useState([vehiclerange.minTopSpeed, vehiclerange.maxTopSpeed]);

  const [trueRange, setTrueRange] = useState([vehiclerange.minRange, vehiclerange.maxRange]);

  const [waitingPeriod, setWaitingPeriod] = useState([0, 240]);
  const [orderby, setOrderby] = useState(6);
  const [filterby, setfilterby] = useState("3");
  // const [selectedImp, setSelectedImp] = useState();
  const [vehicleType, setVehicleType] = useState([]);
  const [selectedAllType, setSelectedAllType] = useState(false);
  const [vehicleSubType, setVehicleSubType] = useState('');
  const [fetchVehicleData, setFetchVehicleData] = useState(false);
  const [fetchBrandData, setFetchBrandData] = useState(false);
  const [routerReady, setRouterReady] = useState(false)
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedMainVehicle, setSelectedMainVehicle] = useState("");
  const [city, setCity] = useState('');
  const [nearby, setNearBy] = useState([])
  const [mainCityChanged, setMainCityChanged] = useState(false);
  const [cityLabel, setCityLabel] = useState(null);
  const [popcityOptions, setPopularCityOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [popularcity, setPopularCity] = useState([
    'Ahmedabad',
    'Bengaluru',
    'Delhi',
    'Jaipur',
    'Kolkata',
    'Mumbai',
    'Pune',
  ]);

  const [popcityid, setpopularcityid] = useState([
    '649e834e0ae8203a2152a521', '649e83670ae8203a2152ac4f', "649e834c0ae8203a2152a491", "649e83ac0ae8203a2152c045",
    "649e83f60ae8203a2152d64c", "649e83920ae8203a2152b8d9", "649e83950ae8203a2152b98f"
  ])

  const [accordian, setAccordian] = useState({
    vehicle_type: false,
    rto: false,
    price: false,
    speed: false,
    range: false,
    waiting: false,
    brands: false
  });

  const [showCityOption, setShowCityOptions] = useState(false);
  const [selectedRto, setSelectedRto] = useState({
    required: false,
    notRequired: false,
  });

  const [isFilterByTwo, setIsFilterByTwo] = useState(false);
  const [loadCities, setLoadCities] = useState(false);
  const [vehicle, setVehicle] = useState([]);
  const [toggleTooltip, setToggleTooltip] = useState(true);
  const [toggleTooltipRange, setToggleTooltipRange] = useState(true);
  const [toggleTooltipSpeed, setToggleTooltipSpeed] = useState(true);
  const [availableFilterData, setAvailableFilterData] = useState(null);
  const [subCity, setSubCity] = useState([])
  const [subCityDetected, setSubCityDetected] = useState(false);

  // useEffect(() => {
  //   getVehicleRange();
  // }, []);

  useEffect(() => {
    let vehicle_type = []
    if (router.pathname === '/electric-vehicles') {
      vehicle_type = ['1', '2', '10', '20']
    }
    if (router.pathname === '/electric-two-wheelers') {
      vehicle_type = ['1', '2']
    }
    if (router.pathname === '/electric-commercial-vehicles') {
      vehicle_type = ['20']
    }
    if (router.pathname === '/electric-scooters') {
      vehicle_type = ['2']
    }
    if (router.pathname === '/electric-bikes') {
      vehicle_type = ['1']
    }
    if (router.pathname === '/electric-cars') {
      vehicle_type = ['10']
    }

    setVehicleType(vehicle_type)
    setRouterReady(true)
  }, []);

  useEffect(() => {
    if (price || truerange) {
      const priceArray = price.split(',')
      // console.log(priceArray)
      priceArray.length === 1 ? setBudget([priceArray[0], vehiclerange.maxBudget]) : setBudget([priceArray[0], priceArray[1]])
      const rangeArray = truerange.split(',')
      // console.log(rangeArray)
      rangeArray.length === 1 ? setTrueRange([rangeArray[0], vehiclerange.maxRange]) : setTrueRange([rangeArray[0], rangeArray[1]])
      setTopSpeed([vehiclerange.minTopSpeed, vehiclerange.maxTopSpeed]);
    }
    else if (localStorage.getItem('filterData')) {
      // console.log('else if going')
      let LocalFilter = JSON.parse(localStorage.getItem('filterData'))
      LocalFilter?.rtoRegistration && setRtoRegistration(LocalFilter?.rtoRegistration)
      LocalFilter?.vehicle_type && setVehicleType(LocalFilter.vehicle_type.split(',').map((s) => { return s }))
      LocalFilter?.company && setSelectedBrands(LocalFilter.vehicle_type.split(',').map((s) => { return s }))
      LocalFilter?.top_speed && setTopSpeed([parseInt(LocalFilter?.top_speed_from), parseInt(LocalFilter?.top_speed_to)])
      LocalFilter?.true_range && setTrueRange([parseInt(LocalFilter?.true_range_from), parseInt(LocalFilter?.true_range_to)])
      LocalFilter?.waiting_period && setWaitingPeriod([parseInt(LocalFilter?.waiting_period_from / 30), parseInt(LocalFilter?.waiting_period_to / 30)])
      LocalFilter?.budget && setBudget([parseInt(LocalFilter?.budget_from), parseInt(LocalFilter?.budget_to)])
    }
    else if (vehiclerange) {
      // console.log('else going', vehiclerange)
      setBudget([parseInt(vehiclerange?.minBudget), parseInt(vehiclerange?.maxBudget)]);
      setTrueRange([vehiclerange?.minRange, vehiclerange?.maxRange]);
      setTopSpeed([vehiclerange?.minTopSpeed, vehiclerange?.maxTopSpeed]);
    }


    setFetchVehicleData(false)

  }, [vehiclerange]);

  useEffect(() => {
    if (!fetchVehicleData && routerReady) {
      window.scrollTo(0, 0)
      TriggerLoader()
      let filterdata = {
        order_by: orderBy && orderBy,
        filter_by: filterBy && filterBy,
        rtoRegistration:
          selectedRto.required === selectedRto.notRequired
            ? ''
            : selectedRto.required,
        limit: 9,
        page: pageChanges ? page : 1,
        city: selectedCity && selectedCity.value?.split(' ').join(' '),
        cityId: selectedCity && selectedCity?.id
      };
      if (selectedBrands) {
        const value = selectedBrands.toString();
        filterdata.company = value;
      }
      if (vehicleType) {
        const value = vehicleType.toString();
        filterdata.vehicle_type = value;
      }
      if (waitingPeriod.length > 0) {
        filterdata.waiting_period = 'waiting_period';
        filterdata.waiting_period_from = waitingPeriod[0] * 30;
        filterdata.waiting_period_to = waitingPeriod[1] * 30;
      }
      if (budget[0] && budget[1]) {
        filterdata.budget = 'budget';
        filterdata.budget_from = budget[0];
        filterdata.budget_to = budget[1];
      }
      if (topSpeed[0] && topSpeed[1]) {
        filterdata.top_speed = 'top_speed';
        filterdata.top_speed_from = topSpeed[0];
        filterdata.top_speed_to = topSpeed[1];
      }
      if (trueRange[0] && trueRange[1]) {
        filterdata.true_range = 'true_range';
        filterdata.true_range_from = trueRange[0];
        filterdata.true_range_to = trueRange[1];
      }
      setFetchVehicleData(true)
      setPageChages(false)
      getFilteredVehicles(filterdata)
      getFilteredCompanies(filterdata)
      // localStorage.setItem('filterData', JSON.stringify(filterdata))
    }
  }, [
    budget,
    topSpeed,
    trueRange,
    waitingPeriod,
    selectedCity,
    vehicleType,
    orderBy,
    filterBy,
    fetchVehicleData,
    page,
    vehicleSubType,
    selectedBrands,
    selectedRto,
    routerReady
  ]);


  useEffect(() => {
    setFetchVehicleData(false)
  }, [orderBy, filterBy, page])

  const handleRTO = (e) => {
    const { value, checked } = e.target;
    const prevState = { ...selectedRto };

    if (value === 'true') {
      prevState.required = checked;
    } else if (value === 'false') {
      prevState.notRequired = checked;
    }
    setSelectedRto({ ...prevState });
    setFetchVehicleData(false);
  };

  const handleVehicles = (e) => {
    if (vehicleType.includes('1') && vehicleType.includes('2')) {
      const temp = vehicleType.filter((s) => (
        s !== '1' && s !== '2'
      ))
      setVehicleType(temp);
      setSelectedAllType(false);
    }
    else if (vehicleType.includes('1')) {
      const temp = [...vehicleType]
      temp.push('2')
      setVehicleType(temp)
    }
    else if (vehicleType.includes('2')) {
      const temp = [...vehicleType]
      temp.push('1')
      setVehicleType(temp)
    }
    else {
      const temp = [...vehicleType]
      temp.push('1')
      temp.push('2')
      setVehicleType(temp)
    }
    setFetchVehicleData(false)
  }

  const addvehicle = (vehicle) => {
    var vehicles = [...vehicleType];
    vehicles.push(vehicle.target.value);
    if (vehicles.length === 4) setSelectedAllType(true)
    setVehicleType(vehicles);
    setFetchVehicleData(false);
  };

  const removeVehicle = (vehicle) => {
    let vehicles = [...vehicleType];
    const demo = vehicles.filter((b) => {
      return b != vehicle.target.value;
    });
    vehicles = demo;
    setVehicleType(vehicles);
    if (selectedAllType) {
      setSelectedAllType(false);
    }
    setFetchVehicleData(false);
  };

  const addAllVehicle = () => {
    if (!selectedAllType) {
      setVehicleType(['1', '2', '10', '20'])
      setSelectedAllType(true)
    }
    else {
      setVehicleType([])
      setSelectedAllType(false)
    }
    setFetchVehicleData(false);
  };

  const onChange = (value, type) => {
    if (type === "budget") setBudget(value);
    if (type === "speed") setTopSpeed(value);
    if (type === "range") setTrueRange(value);
    if (type === "waiting") setWaitingPeriod(value);
    setFetchVehicleData(false);
  };

  const onAfterChange = (value, type) => {
    if (type === "budget") setBudget(value);
    if (type === "speed") setTopSpeed(value);
    if (type === "range") setTrueRange(value);
    if (type === "waiting") setWaitingPeriod(value);
    setFetchVehicleData(false);
  };

  const formatter = (value, type) => {
    if (type === "budget")
      return <div className="">{`₹ ${(value / 100000).toFixed(2)} L`}</div>;
    if (type === "speed") return <div className="">{`${value} Km/h`}</div>;
    if (type === "range") return <div className="">{`${value} Km`}</div>;
    if (type === "waiting") return <div className="">{`${value} Month`}</div>;
  };

  const addBrands = (brand) => {
    var brands = [...selectedBrands];
    brands.push(brand._id);
    // if (!brands.includes(brand._id)) {
    //   brands.push(brand._id);
    // } else {
    //   brands.push(brand._id);
    //   const data = brands;
    // const final = data.filter((d) => {
    //   return d !== brand._id;
    // });
    // brands = final;
    // }
    setSelectedBrands(brands);
    setFetchVehicleData(false);
    // setSelectedBrands(brand._id);
  };

  const removeBrands = (brand) => {
    let brands = [...selectedBrands];
    const demo = brands.filter((b) => {
      return b !== brand._id;
    });
    brands = demo;
    setSelectedBrands(brands);
    if (selectedAll) {
      setSelectedAll(false);
    }
    setFetchVehicleData(false);
    // setSelectedBrands("");
  };

  const addAllBrands = () => {
    setSelectedAll(!selectedAll);
    if (!selectedAll) {
      let brandData = [...selectedBrands];
      companyData.map((data) => {
        if (!brandData.includes(data._id)) {
          brandData.push(data._id);
        }
      })
      setSelectedBrands(brandData);
    }
    else {
      setSelectedBrands('');
    }
    setFetchVehicleData(false)
  }

  const handlefilterby = (e) => {
    const value = e.target.value;
    if (value === "Available") {
      setfilterby(1);
    }
    if (value === "Upcoming") {
      setfilterby(2);
      setIsFilterByTwo(true);
    }
    if (value === "All") {
      setfilterby(3);
    }
    if (value === '') {
      setfilterby('')
    }
    setFetchVehicleData(false);
  };


  useEffect(() => {
    if (!loadCities) {
      getCities().then((res) => {
        setLoadCities(true);
      });
    }
  }, [loadCities]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const value = JSON.parse(localStorage.getItem("currentLocationGeo"))
      if (value?._id) {
        setSelectedCity({
          label: value.value,
          value: value?.value,
          id: value?._id,
          state: value?.state,
          coordinate: value?.coordinate
        })
        setMainCityChanged(true)
        setFetchVehicleData(false)
      }
    }
  }, [citydata])

  const LocationApi = () => {
    if (!navigator.geolocation) {
      // Geolocation is not supported by the browser
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        getCitybyCoordinates(latitude, longitude).then((res) => {
          const found = res.data.result[0]?.megaCity === 1 ? res.data.result[0] : res.data.result[1];
          const cityDetails = {
            label: found?.name,
            value: found?.name,
            _id: found?._id,
            state: found?.state,
            code: found?.code,
            coordinate: found?.coordinate?.coordinates,
            subCity: res.data.result.length > 1 ? true : false,
          };

          if (res?.data.result.length > 1) {
            const data = res.data.result[0]
            const subcityDetails = {
              label: data?.name,
              value: data?.name,
              _id: data?._id,
              state: data?.state,
              code: data?.code,
              coordinate: data?.coordinate?.coordinates,
            }
            setSubCityDetected(true)
            setSubCity(subcityDetails)
          }

          setSelectedCity(cityDetails);
          setMainCityChanged(false);
          setCityLabel(cityDetails?.value);
          setFetchVehicleData(false);

        });
      });
    }
  };

  const HandleLocation = () => {
    LocationApi();
  }


  useEffect(() => {
    if (selectedCity?.coordinate) {
      getNearByCoordinates(selectedCity?.coordinate[1], selectedCity?.coordinate[0]).then((res) => {
        // console.log(res.data)
        const value = res?.data?.result;
        // console.log(value)
        const locationfinder = {
          label: (
            <div onClick={() => HandleLocation()}>
              <span className='pe-2' style={{ marginTop: '-1%' }}>
                <BiCurrentLocation />
              </span>
              Use Current Location
            </div>
          ),
          value: null,
        };
        const options = []
        options.push(locationfinder);
        options.push({
          label: "NEARBY CITIES",
          value: '',
          isDisabled: true
        })
        const LocalValue = JSON.parse(localStorage.getItem("currentLocationGeo"))
        if (mainCityChanged && LocalValue?.subCity) {
          const subCity = JSON.parse(localStorage.getItem("subCity"))
          options.push(subCity)
        }

        if (subCityDetected) {
          // console.log("detected")
          options.push(subCity)
        }

        value?.map((data) => {
          let cityObj = {
            label: data.name,
            value: data.name,
            _id: data._id,
            state: data.state,
            code: data?.code,
            coordinate: data?.coordinate?.coordinates
          }
          options.push(cityObj);
        })
        setNearBy(options)
        setMainCityChanged(false)
      })
    }
  }, [selectedCity])

  const handleCityChange = (data) => {
    const Analyticsprops = {
      GA: true,
      category: 'Electic vehicle page',
      action: 'Search',
      label: 'Search button clicked!',
    }
    Analytics(Analyticsprops)
    setSelectedCity(data);
    setMainCityChanged(false)
    setCityLabel(data?.value);
    setCity(data?.value)
    setFetchVehicleData(false)

    // setFilterCity(data.value);
  };

  useEffect(() => {
    if (selectedCity?.id) {
      getNearbyCities(selectedCity?.id).then((res) => {
        const value = res.data.result;
        // console.log(value)
        const locationfinder = {
          label: (
            <div onClick={() => HandleLocation()}>
              <span className='pe-2' style={{ marginTop: '-1%' }}>
                <BiCurrentLocation />
              </span>
              Use Current Location
            </div>
          ),
          value: null,
        };
        const options = []
        options.push(locationfinder);
        options.push({
          label: "NEARBY CITIES",
          value: '',
          isDisabled: true
        })
        value.map((data) => {
          let cityObj = {
            label: data.name,
            value: data?.maincitycode ? data.maincitycode : data.name,
            id: data._id,
            state: data.state
          }
          options.push(cityObj);
        })
        setNearBy(options)
      })
    }
    // else {
    //   setNearBy([])
    // }
  }, [selectedCity])


  useEffect(() => {
    const locationfinder = {
      label: (
        <div onClick={() => HandleLocation()}>
          <span className='pe-2' style={{ marginTop: '-1%' }}>
            <BiCurrentLocation />
          </span>
          Use Current Location
        </div>
      ),
      value: null,
    };
    const optionsTitle = {
      label: 'POPULAR CITIES',
      value: '',
      isDisabled: true,
    };
    // finalpopular.push(optionsTitle);
    // console.log(finalpopular);
    var optionsArray = [];
    // optionsArray.push(locationfinder);
    optionsArray.push({
      label: <div>All</div>,
      value: ''
    })
    optionsArray.push(optionsTitle);
    popularcity.map((city) => {
      let dispCity = ahmedabad;
      if (city == 'Ahmedabad') {
        dispCity = ahmedabad;
      } else if (city == 'Bengaluru') {
        dispCity = banglore;
      } else if (city == 'Delhi') {
        dispCity = delhi;
      } else if (city == 'Jaipur') {
        dispCity = jaipur;
      } else if (city == 'Kolkata') {
        dispCity = kolkata;
      } else if (city == 'Mumbai') {
        dispCity = mumbai;
      } else if (city == 'Pune') {
        dispCity = pune;
      } else {
        dispCity = ahmedabad;
      }

      optionsArray.push({
        label: (
          <div>
            <Image
              src={dispCity}
              width='20%'
              height='20%'
              alt='pop-img'
              style={{ width: '15%', paddingRight: '4%', marginTop: '-3%' }}
            />
            &nbsp; {city}
          </div>
        ),
        value: city,
      });
    });
    // console.log(optionsArray)
    popcityid.map((id, i) => {
      optionsArray[i + 2].id = id
    })
    // console.log(optionsArray);
    setPopularCityOptions(optionsArray);

    if (cities) {
      var city = [];
      cities.map((data) => {
        let cityObj = {
          label: data.name,
          value: data.name,
          id: data._id
        };
        city.push(cityObj);
      });
      setCityOptions(city);
    }
  }, [cities]);

  const [cityInputvalue, setCityInputValue] = useState('');
  const debouncedValue = useDebounce(cityInputvalue, 300);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputchange = useCallback((value) => {
    setCityInputValue(value);
    if (value.length > 1) {
      setShowCityOptions(true);
    } else {
      setShowCityOptions(false);
    }
  }, []);

  useEffect(() => {
    if (debouncedValue.length > 0) {
      setIsLoading(true);
      const fetchCities = async () => {
        try {
          await getCities({ page: 1, limit: 20, search: debouncedValue });
          setShowCityOptions(true);
        } catch (error) {
          console.error('Error fetching cities:', error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchCities();
    } else {
      setShowCityOptions(false);
      setCityOptions([]);
    }
  }, [debouncedValue]);

  const customCityStyle = {
    placeholder: (base, state) => ({
      ...base,
      display: state.isFocused ? 'none' : 'block', // Hide placeholder when focused
    }),
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '1px solid #e7e7e7' : '1px solid #e7e7e7', // Add border
      boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 0, 0, 0.05)' : 'none', // Add box shadow on focus
      '&:hover': {
        border: '1px solid #e7e7e7', // Ensure border on hover
      },
      minHeight: '45px',
      height: '45px',
      padding: '5px',
    }),
    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected
        ? '#fcbf00' // Background color for selected option
        : 'white', // Background color for other options
      color: isDisabled
        ? '#929292' // Text color for disabled options
        : 'black', // Text color for other options
      fontSize: isDisabled ? '12px' : '16px', // Font size
      cursor: isDisabled ? 'not-allowed' : 'default', // Cursor style
      fontWeight: isDisabled ? '500' : 'normal', // Font weight
      '&:hover': {
        backgroundColor: isDisabled ? 'white' : '#fcbf00', // No hover background change for disabled
        color: isDisabled ? '#929292' : 'black', // No hover text color change for disabled
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu appears above other elements
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'black', // Color of the selected value
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '2px 8px', // Adjust padding for the value container
    }),
  };

  const onSearchClick = (e) => {
    let filterdata = {
      filter_by: filterby && filterby,
      rtoRegistration:
        selectedRto.required === selectedRto.notRequired
          ? ''
          : selectedRto.required,
      limit: 9,
      page: 1,
      city: selectedCity && selectedCity.value.split(' ').join(' '),
      cityId: selectedCity && selectedCity?.id
    };

    if (selectedBrands) {
      const value = selectedBrands.toString();
      filterdata.company = value;
    }
    if (vehicleType) {
      const value = vehicleType.toString();
      filterdata.vehicle_type = value;
    }
    if (waitingPeriod.length > 0) {
      filterdata.waiting_period = 'waiting_period';
      filterdata.waiting_period_from = waitingPeriod[0] * 30;
      filterdata.waiting_period_to = waitingPeriod[1] * 30;
    }
    if (budget[0] && budget[1]) {
      filterdata.budget = 'budget';
      filterdata.budget_from = budget[0];
      filterdata.budget_to = budget[1];
    }
    if (topSpeed[0] && topSpeed[1]) {
      filterdata.top_speed = 'top_speed';
      filterdata.top_speed_from = topSpeed[0];
      filterdata.top_speed_to = topSpeed[1];
    }
    if (trueRange[0] && trueRange[1]) {
      filterdata.true_range = 'true_range';
      filterdata.true_range_from = trueRange[0];
      filterdata.true_range_to = trueRange[1];
    }
    if (filterdata.filter_by === 2) {
      router.push('/upcoming');
    }
    setFetchVehicleData(true)
    AddFilterData({ ...filterData, ...filterdata })
    localStorage.setItem('filterData', JSON.stringify(filterdata))
    TriggerLoader()
    setOpenFilter(false);
  };

  const onClearClick = (e) => {
    let filterdata = {
      // waiting_period: waitingPeriod && waitingPeriod,
      limit: 9,
      page: 1,
    };
    setBudget([vehiclerange.minBudget, vehiclerange.maxBudget]);
    setTopSpeed([vehiclerange.minTopSpeed, vehiclerange.maxTopSpeed]);
    setTrueRange([vehiclerange.minRange, vehiclerange.maxRange]);
    setWaitingPeriod([0, 8]);
    setfilterby('');
    setCity('');
    AddFilterData({ ...filterdata })
    localStorage.setItem("filterData", JSON.stringify(filterdata));
    localStorage.setItem("isFilter", JSON.stringify(true));
    TriggerLoader()
    setOpenFilter(false)

  }
  const handleAccordian = (value) => {
    setAccordian({
      ...accordian,
      [value]: !accordian[value]
    })
  }

  // useEffect(() => {
  //   if (isMobile && router.pathname === "/upcoming") {
  //     setIsFilterByTwo(true);
  //     const updatedFilterData = { ...filterData, filter_by: 2, order_by: orderby, page: 1 };
  //     AddFilterData(updatedFilterData)
  //   }
  // }, [router.pathname])

  return (
    <section style={{ borderRadius: "10px" }}>
      <div className="  product-filter  py-2">
        <div className="pb-1">Available/Upcoming</div>
        <select className='form-select border-secondary mb-3' style={{ borderRadius: "6px !important" }} onChange={(e) => handlefilterby(e)}>
          <option value='All'>Both</option>
          <option value='Available'>Available</option>
          <option value='Upcoming'>Upcoming</option>
        </select>

        <div className="pb-1">City</div>

          <Select
            placeholder='City'
            styles={customCityStyle}
            value={selectedCity}
            // // noOptionsMessage={() => 'loading...'}
            onInputChange={handleInputchange}
            onChange={(e) => handleCityChange(e)}
            // isClearable
            // components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
            options={showCityOption ? cityOptions : nearby.length > 1 ? nearby : popcityOptions}
          ></Select>


        <div className="mt-3 accordion accordion-flush" id="accordionFlushExample">

          <div className='accordion-item '>
            <h2 className='accordion-header' id='flushVehicleType'>
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.vehicle_type === false
                  })}
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#flush-collapseType'
                aria-expanded='true'
                aria-controls='flush-collapseType'
                onClick={() => handleAccordian("vehicle_type")}
              >
                Vehicle Type
              </button>
            </h2>
            <div
              // id='flush-collapseType'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.vehicle_type === true
                }
              )}
              aria-labelledby='flushVehicleType'
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className='row px-2 '>
                {/* <div className='col-6 px-1 mb-2'> */}
                <div className='col-12 px-1 mb-2 '>
                  <div className='d-flex flex-column text-muted gap-2'>
                    <div className='d-inline-flex justify-content-between '>
                      <label for='two-wheeler'>Two wheeler</label>
                      <Form.Check
                        name='vehical-type'
                        type='checkbox'
                        id='two-wheeler'
                        value={3}
                        className={classNames({
                          // 'selected-product': vehicleType === 1,
                        })}
                        /* onClick={(e) => {
                          setVehicleType(1);
                          setTimeout(() => {
                            setFetchVehicleData(false);
                          }, 500);
                        }} */
                        onClick={(e) => handleVehicles(e)}
                        checked={vehicleType?.includes('1') && vehicleType?.includes('2')}
                      />
                    </div>
                    <div className='custom-border d-flex flex-column'>
                      <div className='ms-3 d-inline-flex justify-content-between'>
                        <label for='scooter'>Scooter</label>
                        <Form.Check
                          type='checkbox'
                          name='vehical-type'
                          id='scooter'
                          value={2}
                          className='mb-2'
                          onClick={(e) => vehicleType.includes('2') ? removeVehicle(e) : addvehicle(e)}
                          checked={vehicleType?.includes('2')}
                        />
                      </div>

                      <div className='ms-3 d-inline-flex justify-content-between'>
                        <label for='bike'>Bike</label>
                        <Form.Check
                          type='checkbox'
                          name='vehical-type'
                          id='bike'
                          value={1}
                          onClick={(e) => vehicleType.includes('1') ? removeVehicle(e) : addvehicle(e)}
                          checked={vehicleType?.includes('1')}
                        />
                      </div>
                    </div>
                    <div className='d-inline-flex justify-content-between'>
                      <label for='four-wheeler'>Four wheeler</label>
                      <Form.Check
                        type='checkbox'
                        name='vehical-type'
                        id='four-wheeler'
                        value={10}
                        className={classNames({
                          // 'selected-product': vehicleType === 2,
                        })}
                        onClick={(e) => vehicleType.includes('10') ? removeVehicle(e) : addvehicle(e)}
                        checked={vehicleType?.includes('10')}
                      />
                    </div>

                    <div className='d-inline-flex justify-content-between'>
                      <label for='commercial'>Commercial</label>
                      <Form.Check
                        type='checkbox'
                        name='vehical-type'
                        id='commercial'
                        value={20}
                        className={classNames({
                          // 'selected-product': vehicleType === 2,
                        })}
                        onClick={(e) => vehicleType.includes('20') ? removeVehicle(e) : addvehicle(e)}
                        checked={vehicleType?.includes('20')}
                      />
                    </div>
                    <div className='d-inline-flex justify-content-between'>
                      <label for='all'>All</label>
                      <Form.Check
                        type='checkbox'
                        name='vehical-type'
                        id='all'
                        value=''
                        onClick={(e) => addAllVehicle(e)}
                        checked={selectedAllType}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <hr className='mb-0 pb-0' />
            <div className='row px-2'>
              <div className='col-12 px-1 mb-2 mt-2'>
                <div className='d-flex justify-content-between mt-2 mb-2'>
                  <label for='subsidy' className='mt-1'>
                    FAME || subsidy
                  </label>
                  <Form.Check
                    type='checkbox'
                    id='subsidy'
                    className={classNames({
                      // 'selected-product': vehicleType === 1,
                    })}
                    onClick={(e) => handleRTO(e)}
                    value='true'
                  />
                </div>
              </div>
            </div> */}
          </div>
          <div className="accordion-item">
            <h2 className='accordion-header' id='flushVehicleType'>
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.rto === false
                  })}
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#flush-collapseType'
                aria-expanded='true'
                aria-controls='flush-collapseType'
                onClick={() => handleAccordian("rto")}
              >
                RTO Registration
              </button>
            </h2>
            <div
              // id='flush-collapseType'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.rto === true
                }
              )}
              aria-labelledby='flushVehicleType'
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className='row px-2 '>
                {/* <div className='col-6 px-1 mb-2'> */}
                <div className='col-12 px-1 mb-2 '>
                  <div className='d-flex flex-column text-muted gap-2'>
                    <div className='d-inline-flex justify-content-between '>
                      <label for='rto-required'>Required</label>
                      <Form.Check
                        type='checkbox'
                        id='rto-required'
                        className={classNames({
                          // 'selected-product': vehicleType === 1,
                        })}
                        onClick={(e) => handleRTO(e)}
                        value='true'
                      /*  onClick={(e) => {
                        setVehicleType(1);
                        setTimeout(() => {
                          setFetchVehicleData(false);
                        }, 500);
                      }} */
                      />
                    </div>
                    <div className='d-inline-flex justify-content-between'>
                      <label for='rto-not-required'>Not Required</label>
                      <Form.Check
                        type='checkbox'
                        id='rto-not-required'
                        className={classNames({
                          // 'selected-product': vehicleType === 2,
                        })}
                        onClick={(e) => handleRTO(e)}
                        value='false'
                      /*   onClick={(e) => {
                      
                        setVehicleType(2);
                        setTimeout(() => {
                          setFetchVehicleData(false);
                        }, 500);
                      }} */
                      />
                    </div>
                  </div>
                  {/*  <button
                    className={classNames(
                      'btn btn-sm product-filter-btn w-100 my-1 my-md-0',
                      {
                        'selected-product': vehicleType === 1,
                      }
                    )}
                    onClick={(e) => {
                      setVehicleType(1);
                      setTimeout(() => {
                        setFetchVehicleData(false);
                      }, 500);
                    }}
                  >
                    Two wheeler
                  </button> */}
                </div>
                {/* <div className='col-6 px-1 mb-2'>
                  <button
                    className={classNames(
                      'btn btn-sm product-filter-btn w-100 my-1 my-md-0',
                      {
                        'selected-product': vehicleType === 2,
                      }
                    )}
                    onClick={(e) => {
                      setVehicleType(2);
                      setTimeout(() => {
                        setFetchVehicleData(false);
                      }, 500);
                    }}
                  >
                    Four Wheeler
                  </button>
                </div> */}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.price === false
                  })}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="true"
                aria-controls="flush-collapseOne"
                onClick={() => {
                  setToggleTooltip(!toggleTooltip);
                  handleAccordian("price")
                }}
              >
                Price Range
              </button>
            </h2>
            <div
              // id='flush-collapseOne'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.price === true
                }
              )}
              aria-labelledby="flush-headingOne"
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body px-1 ">
                <div className="row">
                  <div className="col-6 px-2 mb-2">
                    <div className="only-lbl text-center">
                      Min : ₹ {(budget[0] / 100000).toFixed(2)} L
                    </div>
                  </div>

                  <div className="col-6 px-2 mb-2 float-right">
                    <div className="only-lbl text-center">
                      Max : ₹ {(budget[1] / 100000).toFixed(2)} L
                    </div>
                  </div>
                </div>
                <div id="slider" className="w-100 ">
                  <Slider
                    range
                    step={10000}
                    min={vehiclerange.minBudget}
                    max={vehiclerange.maxBudget}
                    autoFocus={true}
                    value={budget}
                    onChange={(value) => onChange(value, "budget")}
                    onAfterChange={(value) => onAfterChange(value, "budget")}
                    // tooltipPlacement='top'
                    tooltipVisible={false}
                    tipFormatter={(value) => formatter(value, "budget")}
                  />
                </div>
                <div className="row px-1 mt-24 pt-2">
                  <div className="col-6 px-1 mb-2">
                    <button
                      className="btn btn-sm product-filter-btn w-100 my-1 my-md-0"
                      onClick={() => {
                        setBudget([vehiclerange.minBudget, vehiclerange.maxBudget / 4]);
                        setFetchVehicleData(false);
                      }}
                    >
                      ₹ {(vehiclerange.minBudget / 100000).toFixed(2)} L -{' '}
                      {(vehiclerange.maxBudget / 400000).toFixed(2)} L
                    </button>
                  </div>
                  <div className="col-6 px-1 mb-2">
                    <button
                      className="btn btn-sm product-filter-btn w-100 my-1 my-md-0"
                      onClick={() => {
                        setBudget([vehiclerange.maxBudget / 4, vehiclerange.maxBudget / 3]);
                        setFetchVehicleData(false);
                      }}
                    >
                      ₹ {(vehiclerange.maxBudget / 400000).toFixed(2)} L -{' '}
                      {(vehiclerange.maxBudget / 300000).toFixed(2)} L
                    </button>
                  </div>
                  <div className="col-6 px-1 mb-2">
                    <button
                      className="btn btn-sm product-filter-btn w-100 my-1 my-md-0"
                      onClick={() => {
                        setBudget([vehiclerange.maxBudget / 3, vehiclerange.maxBudget / 2]);
                        setFetchVehicleData(false);
                      }}
                    >
                      ₹ {(vehiclerange.maxBudget / 300000).toFixed(2)} L -{' '}
                      {(vehiclerange.maxBudget / 200000).toFixed(2)} L
                    </button>
                  </div>
                  <div className="col-6 px-1 mb-2">
                    <button
                      className="btn btn-sm product-filter-btn w-100 my-1 my-md-0"
                      onClick={() => {
                        setBudget([vehiclerange.maxBudget / 2, vehiclerange.maxBudget]);
                        setFetchVehicleData(false);
                      }}
                    >
                      ₹ {(vehiclerange.maxBudget / 200000).toFixed(2)} L -{' '}
                      {(vehiclerange.maxBudget / 100000).toFixed(2)} L
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingTwo">
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.speed === false
                  })}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="true"
                aria-controls="flush-collapseTwo"
                onClick={() => {
                  setToggleTooltipSpeed(!toggleTooltipSpeed);
                  handleAccordian("speed")
                }}
              >
                Top Speed
              </button>
            </h2>
            <div
              // id='flush-collapseTwo'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.speed === true
                }
              )}
              aria-labelledby="flush-headingTwo"
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body px-1 ">
                <div className="row  ">
                  <div className="col-6 px-2 mb-2">
                    <div className="only-lbl text-center">
                      Min : {topSpeed[0]} km/h
                    </div>
                  </div>

                  <div className="col-6 px-2 mb-2 float-right">
                    <div className="only-lbl text-center">
                      Max : ₹ {topSpeed[1]} km/h
                    </div>
                  </div>
                </div>
                <div className="w-100">
                  <Slider
                    range
                    step={5}
                    min={vehiclerange.minTopSpeed}
                    max={vehiclerange.maxTopSpeed}
                    autoFocus={true}
                    value={topSpeed}
                    onChange={(value) => onChange(value, "speed")}
                    onAfterChange={(value) => onAfterChange(value, "speed")}
                    tooltipVisible={false}
                    tipFormatter={(value) => formatter(value, "speed")}
                  />
                </div>
                <div className="row px-1 mt-4 pt-2">
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            topSpeed[1] === 100 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTopSpeed([25, 100]);
                        setFetchVehicleData(false);
                      }}
                    >
                      100 km/h
                    </button>
                  </div>
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            topSpeed[1] === 150 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTopSpeed([25, 150]);
                        setFetchVehicleData(false);
                      }}
                    >
                      150 km/h
                    </button>
                  </div>
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            topSpeed[1] === 200 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTopSpeed([25, 200]);
                        setFetchVehicleData(false);
                      }}
                    >
                      200 km/h
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingThree">
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.range === false
                  })}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="true"
                aria-controls="flush-collapseThree"
                onClick={() => {
                  setToggleTooltipRange(!toggleTooltipRange);
                  handleAccordian("range")
                }}
              >
                Range
              </button>
            </h2>
            <div
              // id='flush-collapseThree'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.range === true
                }
              )}
              aria-labelledby="flush-headingThree"
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body px-1 ">
                <div className="row">
                  <div className="col-6 px-2 mb-2">
                    <div className="only-lbl text-center">
                      Min : {trueRange[0]} km
                    </div>
                  </div>

                  <div className="col-6 px-2 mb-2 float-right">
                    <div className="only-lbl text-center">
                      Max : {trueRange[1]} km
                    </div>
                  </div>
                </div>
                <div className="w-100 ">
                  <Slider
                    range
                    step={20}
                    min={vehiclerange.minRange}
                    max={vehiclerange.maxRange}
                    autoFocus={true}
                    value={trueRange}
                    onChange={(value) => onChange(value, "range")}
                    onAfterChange={(value) => onAfterChange(value, "range")}
                    tooltipVisible={false}
                    tipFormatter={(value) => formatter(value, "range")}
                  />
                </div>
                <div className="row px-1 mt-2 pt-2 mb-3">
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            trueRange[1] === 100 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTrueRange([60, 100]);
                        setFetchVehicleData(false);
                      }}
                    >
                      100 km
                    </button>
                  </div>
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            trueRange[1] === 200 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTrueRange([60, 200]);
                        setFetchVehicleData(false);
                      }}
                    >
                      200 km
                    </button>
                  </div>
                  <div className="col-4 px-1 mb-2">
                    <button
                      className={classNames(
                        "btn btn-sm product-filter-btn w-100 my-1 my-md-0",
                        {
                          "selected-product":
                            trueRange[1] === 300 ? true : false,
                        }
                      )}
                      onClick={() => {
                        setTrueRange([60, 300]);
                        setFetchVehicleData(false);
                      }}
                    >
                      300 km
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-waiting-header">
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.waiting === false
                  })}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-waiting"
                aria-expanded="true"
                aria-controls="flush-waiting"
                onClick={() => {
                  setToggleTooltipRange(!toggleTooltipRange);
                  handleAccordian("waiting")
                }}
              >
                Waiting Period
              </button>
            </h2>
            <div
              // id='flush-waiting'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.waiting === true
                }
              )}
              aria-labelledby="flush-waiting-header"
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body px-1 ">
                <div className="row  ">
                  <div className="col-6 px-2 mb-2">
                    <div className="only-lbl text-center">
                      Min : {waitingPeriod[0]}{" "}
                      {waitingPeriod[0] > 1 ? " Months" : " Month"}
                    </div>
                  </div>
                  <div className="col-6 px-1 mb-2 float-right">
                    <div className="only-lbl text-center">
                      Max : {waitingPeriod[1]}
                      {waitingPeriod[1] > 1 ? " Months" : " Month"}
                    </div>
                  </div>
                  <div className="">
                    <Slider
                      range
                      step={1}
                      min={0}
                      max={8}
                      autoFocus={true}
                      value={waitingPeriod}
                      onChange={(value) => onChange(value, "waiting")}
                      onAfterChange={(value) => onAfterChange(value, "waiting")}
                      tooltipVisible={false}
                      tipFormatter={(value) => formatter(value, "waiting")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFive">
              <button
                className={classNames('accordion-button fs-14 px-0',
                  {
                    "collapsed": accordian.brands === false
                  })}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFive"
                // aria-expanded='true'
                aria-controls="flush-collapseFive"
                onClick={() => handleAccordian("brands")}
              >
                Brands
              </button>
            </h2>
            <div
              // id='flush-collapseFive'
              className={classNames('accordion-collapse collapse',
                {
                  'show': accordian.brands === true
                }
              )}
              aria-labelledby="flush-headingFive"
            //   data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body px-0 py-0">
                <div className="form-check px-0 mb-1 d-flex align-items-center justify-content-between">
                  <label
                    className="form-check-label color-d-gray"
                  // htmlFor={brand._id}
                  // onClick={() =>
                  //   selectedBrands === brand._id
                  //     ? removeBrands(brand)
                  //     : addBrands(brand)
                  // }
                  >
                    All
                  </label>
                  <input
                    className="form-check-input float-end"
                    type="checkbox"
                    checked={selectedAll}
                    // id={brand._id}
                    // onChange={() =>
                    //   !selectedBrands.includes(brand._id)
                    //     ? addBrands(brand)
                    //     : removeBrands(brand)
                    // }
                    onChange={() =>
                      addAllBrands()
                    }
                  />
                </div>
                {filteredCompanies.length > 0 && !companiesLoading
                  ? filteredCompanies.map((brand) => (
                    <div
                      className="form-check px-0 mb-1 d-flex align-items-center justify-content-between"
                      key={brand._id}
                    >
                      <label
                        className="form-check-label color-d-gray"
                        // htmlFor={brand._id}
                        // onClick={() =>
                        //   !selectedBrands.includes(brand._id)
                        //     ? addBrands(brand)
                        //     : removeBrands(brand)
                        // }
                        onClick={() =>
                          selectedBrands.includes(brand._id)
                            ? removeBrands(brand)
                            : addBrands(brand)
                        }
                      >
                        {brand.title}
                      </label>
                      <input
                        className="form-check-input float-end"
                        type="checkbox"
                        checked={selectedBrands.includes(brand._id) || selectedAll}
                        id={brand._id}
                        // onChange={() =>
                        //   !selectedBrands.includes(brand._id)
                        //     ? addBrands(brand)
                        //     : removeBrands(brand)
                        // }
                        onChange={() =>
                          selectedBrands.includes(brand._id)
                            ? removeBrands(brand)
                            : addBrands(brand)
                        }
                      />
                    </div>
                  ))
                  : null}
                <div className="color-d-gray mt-3 mb-3">
                  {/* <span className="c-pointer">
                    Show more
                    <i className="fas fa-chevron-down small-lbl ps-2"></i>
                  </span> */}
                </div>
              </div>
            </div>
          </div>


          <div className="d-flex justify-content-between align-items-center mt-4">
            <span className='clear-btn' onClick={(e) => onClearClick(e)}>
              Clear All
            </span>
            <button
              className='btn btn-warning mob-filter-btn'
              onClick={(e) => onSearchClick(e)}
            >
              Apply Filters
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
